@if (visible) {
  <div class="kvkk-modal-backdrop">
    <div class="kvkk-modal-content">
      <div class="kvkk-modal-header">
        <h3 class="amts-text-g900 fw-bolder mb-0">
          {{ "auth.login.confirmationsTitle" | translate }}
        </h3>
        <button
          type="button"
          class="kvkk-modal-close"
          aria-label="Close"
          (click)="cancel()"
        >
          &times;
        </button>
      </div>

      <div class="kvkk-modal-body">
        <div class="kvkk-stepper">
          <div class="stepper-track" [class.two-step]="isVideoCall()" [class.single-step]="!isVideoCall()">
            <div class="step" [class.active]="consentStep === 0">
              <span class="step-index">1</span>
              <span class="step-label">{{
                "auth.login.mediaAudioTitle" | translate
              }}</span>
            </div>
            @if (isVideoCall()) {
              <div class="step" [class.active]="consentStep === 1">
                <span class="step-index">2</span>
                <span class="step-label">{{
                  "auth.login.mediaVideoTitle" | translate
                }}</span>
              </div>
            }
          </div>

          @if (consentStep === 0) {
            <div class="step-panel">
              <div class="kvkk-text-section">
                <h4 class="consent-heading">
                  {{ "auth.login.audioConsentHeading" | translate }}
                </h4>
                <div class="kvkk-html" [innerHTML]="audioHtmlSafe"></div>
              </div>
              <div class="consent-actions">
                <button
                  type="button"
                  class="consent-btn"
                  [class.active]="audioConsent"
                  (click)="setAudioConsent(true)"
                >
                  {{ "auth.login.consentYes" | translate }}
                </button>
                <button
                  type="button"
                  class="consent-btn"
                  [class.active]="!audioConsent"
                  (click)="setAudioConsent(false)"
                >
                  {{ "auth.login.consentNo" | translate }}
                </button>
              </div>
            </div>
          } @else if (isVideoCall()) {
            <div class="step-panel">
              <div class="kvkk-text-section">
                <h4 class="consent-heading">
                  {{ "auth.login.videoConsentHeading" | translate }}
                </h4>
                <div class="kvkk-html" [innerHTML]="videoHtmlSafe"></div>
              </div>
              <div class="consent-actions">
                <button
                  type="button"
                  class="consent-btn"
                  [class.active]="videoConsent"
                  (click)="setVideoConsent(true)"
                >
                  {{ "auth.login.consentYes" | translate }}
                </button>
                <button
                  type="button"
                  class="consent-btn"
                  [class.active]="!videoConsent"
                  (click)="setVideoConsent(false)"
                >
                  {{ "auth.login.consentNo" | translate }}
                </button>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="kvkk-modal-footer">
        <div class="footer-actions">
          @if (isVideoCall() && consentStep > 0) {
            <button
              type="button"
              class="btn btn-secondary"
              (click)="prevConsentStep()"
            >
              {{ "general.previous" | translate }}
            </button>
          }
          @if (!isVideoCall()) {
            <button
              type="button"
              class="btn amts-bg-el23 amts-text-white"
              (click)="confirm()"
            >
              {{ "auth.login.continue" | translate }}
            </button>
          } @else if (consentStep < 1) {
            <button
              type="button"
              class="btn amts-bg-el23 amts-text-white"
              (click)="nextConsentStep()"
            >
              {{ "auth.login.continue" | translate }}
            </button>
          } @else {
            <button
              type="button"
              class="btn amts-bg-el23 amts-text-white"
              (click)="confirm()"
            >
              {{ "auth.login.continue" | translate }}
            </button>
          }
        </div>
      </div>
    </div>
  </div>
}
